import { axiosInstance as request } from '@api/rest.service'

const api = '/member-settings'

/**
 * @description GET /member-settings
 * @returns {AxiosPromise<any>}
 */
export const GET_MEMBER_SETTINGS = () => request.get(api)

/**
 * @description PUT /member-settings
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_MEMBER_SETTINGS = payload => request.put(api, payload)
